import React from "react";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Tooltip,
  Typography,
  Button,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { getCountryName } from "../../../utils/addressData";

export default function AddressCard({
  address,
  index,
  validationErrors,
  selectedIndex,
  showOutgoingCheckbox,
  onEdit,
  onDelete,
  onToggleOutgoing,
}) {
  const hasErrors = validationErrors && Object.keys(validationErrors).length > 0;
  const disableOutgoing =
    selectedIndex !== -1 && selectedIndex !== index;

  return (
    <Grid2 item xs={12} sm={6} md={4}>
      <Card
        variant="outlined"
        sx={{
          borderRadius: 3,
          height: "100%",
          boxShadow: "0 8px 28px rgba(0,0,0,0.06)",
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 1,
              mb: 0.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="subtitle1" fontWeight={700}>
                {address.label || "—"}
              </Typography>
              {hasErrors && (
                <Tooltip title={Object.values(validationErrors).join("; ")}>
                  <Chip label="Fehler" size="small" color="error" variant="outlined" />
                </Tooltip>
              )}
            </Box>
            {address.forOutgoingInvoice && (
              <Chip label="Standard" size="small" color="success" variant="outlined" />
            )}
          </Box>
          <Divider sx={{ mb: 1 }} />
          <Typography variant="body2">{address.name || "—"}</Typography>
          <Typography variant="body2">{address.street || "—"}</Typography>
          <Typography variant="body2">
            {(address.zip || "—") + " " + (address.city || "")}
          </Typography>
          <Typography variant="body2">{getCountryName(address.country)}</Typography>

          <Tooltip
            title={
              disableOutgoing ? "Es ist bereits eine Standardadresse ausgewählt" : ""
            }
          >
            <span>
              {showOutgoingCheckbox && (
                <FormControlLabel
                  sx={{ mt: 1 }}
                  control={
                    <Checkbox
                      checked={!!address.forOutgoingInvoice}
                      onChange={() => onToggleOutgoing(index)}
                      disabled={disableOutgoing}
                    />
                  }
                  label="Für Ausgangsrechnungen verwenden"
                />
              )}
            </span>
          </Tooltip>
        </CardContent>

        <CardActions sx={{ pt: 0, pb: 2, px: 2 }}>
          <Button size="small" onClick={() => onEdit(index)}>
            Bearbeiten
          </Button>
          <Button size="small" color="error" onClick={() => onDelete(index)}>
            Löschen
          </Button>
        </CardActions>
      </Card>
    </Grid2>
  );
}
